module.exports = __webpack_public_path__ + "img/heart-empty.b34fe13a.svg";